import React from 'react';
import { Button, Icon } from '@dotcom/crown-ui';
import classNames from 'classnames';
import styles from './icon-button.module.scss';

type IconButtonProps = {
  onClick: () => void;
  className?: string;
  label: string;
  testId?: string;
  iconTestId?: string;
  iconClassName?: string;
  iconPosition?: 'left' | 'right';
  labelClassName?: string;
  type?: React.ComponentProps<typeof Button>['type'];
  variant?: React.ComponentProps<typeof Button>['variant'];
  iconName: React.ComponentProps<typeof Icon>['name'];
  iconColor?: React.ComponentProps<typeof Icon>['color'];
  iconSize?: React.ComponentProps<typeof Icon>['size'];
};

export const IconButton: React.FC<IconButtonProps> = ({
  testId,
  iconTestId,
  onClick,
  type = 'button',
  variant = 'link',
  className,
  label,
  iconName,
  iconColor = 'blue',
  iconSize = '12',
  iconClassName,
  labelClassName,
  iconPosition = 'left',
}) => {
  const positionClass = iconPosition === 'left' ? styles['icon-left'] : styles['icon-right'];
  const buttonClass = classNames(className, styles['icon-button'], positionClass);
  return (
    <Button testId={testId} onClick={onClick} type={type} variant={variant} className={buttonClass}>
      {iconPosition === 'left' && (
        <Icon
          testId={iconTestId}
          className={classNames(iconClassName, styles['icon-button-icon'])}
          color={iconColor}
          name={iconName}
          size={iconSize}
        />
      )}
      <span className={classNames(styles['icon-button-label'], labelClassName)}>{label}</span>
      {iconPosition === 'right' && (
        <Icon
          className={classNames(iconClassName, styles['icon-button-icon'])}
          color={iconColor}
          name={iconName}
          size={iconSize}
          testId={iconTestId}
        />
      )}
    </Button>
  );
};
